import type { ApiRoute, NoPathParams, NoQueryParams } from "../api"
import type { AddInventoryVehicleResult } from "./AddInventoryVehicleResult"

export interface AddInventoryVehicleBody {
	identified: boolean
	vin: string
}

export const addInventoryVehicleRoute: ApiRoute<
	NoPathParams,
	NoQueryParams,
	AddInventoryVehicleBody,
	AddInventoryVehicleResult
> = {
	buildUrl: () => "/vehicles",
	method: "post",
	path: "/vehicles",
}
